import React from "react";
import { Link } from "react-router-dom";

const ERP = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-[#f8f9fc]">


      {/* ================= LEFT SECTION ================= */}

      <div
        className="
        lg:w-[60%]
        min-h-[55vh]
        lg:min-h-screen
        flex
        items-center
        bg-gradient-to-br
        from-[#002147]
        via-[#073b73]
        to-[#0b4b87]
        "
      >

        <div className="px-6 sm:px-10 lg:px-20 py-12 text-white">


          {/* TAG */}

          <p className="
          text-yellow-400
          uppercase
          tracking-[5px]
          text-sm
          font-bold
          mb-6
          ">
            ERP Portal
          </p>


          {/* TITLE */}

          <h1
            className="
            text-3xl
            sm:text-5xl
            lg:text-6xl
            font-black
            leading-tight
            mb-6
            "
          >
            Cambridge
            <br />
            International School
          </h1>



          {/* TEXT */}

          <p
            className="
            text-base
            sm:text-lg
            leading-8
            max-w-xl
            text-gray-200
            "
          >
            Excellence in Education. Access student,
            parent, teacher and administration services
            through our secure ERP portal.
          </p>



          {/* FEATURES */}

          <div className="flex flex-wrap gap-3 mt-8">


            {[
              "Student Portal",
              "Parent Access",
              "Teacher Dashboard",
              "Secure Login",
            ].map((item, index) => (

              <span
                key={index}
                className="
                bg-white/20
                backdrop-blur-md
                px-5
                py-3
                rounded-full
                text-sm
                border
                border-white/20
                "
              >
                ✓ {item}
              </span>

            ))}


          </div>


        </div>


      </div>





      {/* ================= LOGIN SECTION ================= */}


      <div
        className="
        lg:w-[40%]
        flex
        items-center
        justify-center
        px-5
        py-10
        "
      >


        <div
          className="
          w-full
          max-w-md
          bg-white
          rounded-[35px]
          shadow-[0_25px_80px_rgba(0,0,0,0.12)]
          p-6
          sm:p-10
          "
        >



          <h2
            className="
            text-3xl
            font-black
            text-center
            text-[#002147]
            "
          >
            ERP Login Portal
          </h2>



          <p
            className="
            text-center
            text-gray-500
            mt-3
            mb-8
            "
          >
            Login to continue
          </p>





          {/* ROLE SELECT */}


          <select
            className="
            w-full
            px-4
            py-4
            rounded-xl
            border
            border-gray-200
            mb-4
            outline-none
            focus:border-[#002147]
            "
          >

            <option>
              Student
            </option>

            <option>
              Parent
            </option>

            <option>
              Teacher
            </option>

            <option>
              Admin
            </option>


          </select>





          {/* USERNAME */}


          <input
            type="text"
            placeholder="Username"
            className="
            w-full
            px-4
            py-4
            rounded-xl
            border
            border-gray-200
            mb-4
            outline-none
            focus:border-[#002147]
            "
          />





          {/* PASSWORD */}


          <input
            type="password"
            placeholder="Password"
            className="
            w-full
            px-4
            py-4
            rounded-xl
            border
            border-gray-200
            mb-6
            outline-none
            focus:border-[#002147]
            "
          />





          {/* LOGIN BUTTON */}


          <button
            className="
            w-full
            py-4
            rounded-xl
            bg-[#002147]
            text-white
            font-bold
            hover:bg-[#073b73]
            transition
            duration-300
            "
          >
            Login
          </button>





          {/* FORGOT */}


          <div className="text-center mt-5">

            <a
              href="/"
              className="
              text-blue-600
              hover:underline
              "
            >
              Forgot Password?
            </a>


          </div>





          {/* BACK */}


          <Link
            to="/"
            className="
            block
            text-center
            mt-8
            font-semibold
            text-[#002147]
            hover:text-blue-600
            transition
            "
          >
            ← Back To Website
          </Link>




        </div>


      </div>


    </div>
  );
};


export default ERP;